import styled, { keyframes } from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import { palette, variant } from '../../utils/theme.es.js';
import { Card } from '../Card/Card.es.js';
import { Shelf } from '../../primitives/Shelf/Shelf.es.js';
import { Group } from '../../primitives/Group/Group.es.js';
var TRANSITION_DURATION = 500;
var openAnimation = keyframes(["from{opacity:0;}to{opacity:1;}"]);
var closeAnimation = keyframes(["from{opacity:1;}to{opacity:0;}"]);
var FeatureCard = styled(Card).withConfig({
  componentId: "g6e6un-0"
})(["background-color:", ";border:none;position:absolute;top:0;left:0;bottom:0;right:0;"], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
});
var FeatureCardContent = styled(Card.Content).withConfig({
  componentId: "g6e6un-1"
})(["height:100%;"]);
var featureCardShapeStyles = variant({
  prop: "shape",
  variants: {
    square: {
      "&:before": {
        paddingTop: "100%"
      }
    },
    rectangle: {
      "&:before": {
        paddingTop: "49.67%",
        minHeight: "150px"
      }
    }
  }
});
var FeatureCardWrapper = styled(Box).withConfig({
  componentId: "g6e6un-2"
})(["position:relative;width:100%;overflow:hidden;&:before{content:'';display:block;}", ";", "{background-image:url(", ");background-size:cover;background-position:50% 50%;}"], featureCardShapeStyles, FeatureCard, function (_ref2) {
  var backgroundImage = _ref2.backgroundImage;
  return backgroundImage;
});
var FeatureCardMedia = styled(Box).withConfig({
  componentId: "g6e6un-3"
})(["background-color:", ";box-shadow:0 2px 4px 0 rgba(20,39,57,0.24);"], palette("neutral.900"));
var FeatureCardShelf = styled(Shelf).withConfig({
  componentId: "g6e6un-4"
})(["height:100%;"]);
var FeatureCardGroup = styled(Group).withConfig({
  componentId: "g6e6un-5"
})(["&.entering{animation:", " ", "ms ease both;}&.exiting{animation:", " ", "ms ease both;}"], openAnimation, TRANSITION_DURATION, closeAnimation, TRANSITION_DURATION);
export { FeatureCard, FeatureCardContent, FeatureCardGroup, FeatureCardMedia, FeatureCardShelf, FeatureCardWrapper, TRANSITION_DURATION };